import { LogLevel } from "../enums";

export class LogSystemLevelUtils {

  static getClass(logLevel: LogLevel | string | undefined | null): string {

    if (logLevel === undefined || logLevel === null || logLevel === "-") {
      return "";
    }

    let className: string = "isg-loglevel-";

    switch (logLevel!) {
      case LogLevel.Trace:
        className += "trace";
        break;
      case LogLevel.Debug:
        className += "debug";
        break;
      case LogLevel.Information:
        className += "information";
        break;
      case LogLevel.Warning:
        className += "warning";
        break;
      case LogLevel.Error:
        className += "error";
        break;
      case LogLevel.Critical:
        className += "critical";
        break;
      case LogLevel.None:
        className += "none";
        break;
      default:
        return "";
        break;
    }

    return className;
  }
}
